export const idToSectionMapping: Record<string, string> = {
    // --- Self Employment General ---
    "SELF_EMPLOYMENT_PROFILES": "SELF_EMPLOYMENT_PROFILES",
    "SELF_EMPLOYMENT_NAME": "SELF_EMPLOYMENT_NAME",
    "SELF_EMPLOYMENT_INDUSTRY": "SELF_EMPLOYMENT_NAME",
    "SELF_EMPLOYMENT_INDUSTRY_OTHER": "SELF_EMPLOYMENT_NAME",
    "SELF_EMPLOYMENT_ADDRESS_SELECT": "SELF_EMPLOYMENT_NAME",
    "SELF_EMPLOYMENT_ADDRESS_OTHER": "SELF_EMPLOYMENT_NAME",
    "SELF_EMPLOYMENT_TRADING_NAME_ADDRESS_CHANGE": "SELF_EMPLOYMENT_NAME",
    // --- Self Employment Income ---
    "SELF_EMPLOYMENT_MANUAL_INCOME": "SELF_EMPLOYMENT_MANUAL_INCOME",
    "SELF_EMPLOYMENT_INCOME_SUMMARY": "SELF_EMPLOYMENT_MANUAL_INCOME",
    // --- Self Employment Business Losses ---
    "SELF_EMPLOYMENT_BUSINESS_LOSSES": "SELF_EMPLOYMENT_BUSINESS_LOSSES_CARD",
    "SELF_EMPLOYMENT_BUSINESS_LOSSES_CARD": "SELF_EMPLOYMENT_BUSINESS_LOSSES_CARD",
    "SELF_EMPLOYMENT_BUSINESS_LOSSES_AMOUNT": "SELF_EMPLOYMENT_BUSINESS_LOSSES_CARD",
    // --- Self Employment Capital Allowances ---
    "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_VEHICLE_DETAILS_ARRAY": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_TYPE": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_MAKE_MODEL": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_CLAIM_METHOD": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_MILEAGE_DRIVEN": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_TYPE_NEW_USED": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_PURCHASE_DATE": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_PURCHASE_PRICE": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_SALE": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_SALE_DATE": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_SALE_PRICE": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    "SELF_EMPLOYMENT_CAR_PERSONAL_USAGE": "SELF_EMPLOYMENT_USED_VEHICLE_QUESTION",
    // --- Self Employment Expenses ---
    "SELF_EMPLOYMENT_EXPENSES": "SELF_EMPLOYMENT_EXPENSES_SUMMARY",
    "SELF_EMPLOYMENT_EXPENSES_SUMMARY": "SELF_EMPLOYMENT_EXPENSES_SUMMARY",
    // --- Employment General ---
    "EMPLOYMENT_PROFILES": "EMPLOYMENT_PROFILES",
    "EMPLOYMENT_NAME": "EMPLOYMENT_NAME",
    "EMPLOYMENT_INDUSTRY": "EMPLOYMENT_NAME",
    "EMPLOYMENT_SUB_INDUSTRY": "EMPLOYMENT_NAME",
    "EMPLOYMENT_JOB_TITLE": "EMPLOYMENT_NAME",
    // --- Employment Flat Rate Expenses ---
    "EMPLOYMENT_FLAT_RATE_EXPENSES_CARD": "EMPLOYMENT_NAME",
    // --- Employment Company Director ---
    "EMPLOYMENT_COMPANY_DIRECTOR": "EMPLOYMENT_NAME",
    "EMPLOYMENT_COMPANY_DIRECTOR_CARD": "EMPLOYMENT_NAME",
    "EMPLOYMENT_DIRECTOR_CEASE_EMPLOYMENT_CARD": "EMPLOYMENT_NAME",
    "EMPLOYMENT_DIRECTOR_CEASE_DATE": "EMPLOYMENT_NAME",
    "EMPLOYMENT_DIRECTOR_COMPANY_SIZE": "EMPLOYMENT_NAME",
    "EMPLOYMENT_DIRECTOR_COMPANY_SIZE_CARD": "EMPLOYMENT_NAME",
    "EMPLOYMENT_START_END_DATE": "EMPLOYMENT_NAME",
    "EMPLOYMENT_START_DATE": "EMPLOYMENT_NAME",
    "EMPLOYMENT_END_DATE": "EMPLOYMENT_NAME",
    // --- Employment Income ---
    "EMPLOYMENT_P60": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_P45": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_INCOME_SUMMARY": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_REDUNDANCY_PAYMENTS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_REDUNDANCY_PAYMENTS_CARD": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_REDUNDANCY_PAYMENTS_AMOUNT": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_REDUNDANCY_PAYMENTS_TAX": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_TIPS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_TIPS_CARD": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_TIPS_AMOUNT": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_CARD": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_AMOUNTS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_ASSETS_TRANSFERRED": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_PAYMENTS_BEHALF_OF_EMPLOYEE": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_VOUCHER_CREDIT_CARDS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_LIVING_ACCOMMODATION": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_MILEAGE_ALLOWANCE_PAYMENTS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_CARS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_CAR_FUEL": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_INTEREST_FREE_LOW_INTEREST_LOANS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_PRIVATE_MEDICAL_TREATMENT_INSURANCE": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_QUALIFYING_RELOCATION_EXPENSES_PAYMENTS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_SERVICES_SUPPLIED": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_ASSETS_PLACED_EMPLOYEE_DISPOSAL": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_OTHER_ITEMS": "EMPLOYMENT_INCOME_SUMMARY",
    "EMPLOYMENT_BENEFITS_P11D_LIST_EXPENSE_PAYMENTS": "EMPLOYMENT_INCOME_SUMMARY",
    // --- Employment Expenses ---
    "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_TRAVEL_EXPENSES": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_SUBSISTENCE": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_PUBLIC_TRANSPORT": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_PARKING": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_ACCOMMODATION": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_CAR_MILES": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_CAR_MILES_AMOUNT": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_CAR_REIMBURSED": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_MOTORCYCLE_MILES": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_MOTORCYCLE_MILES_AMOUNT": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_MOTORCYCLE_REIMBURSED": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_CYCLE_MILES": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_CYCLE_MILES_AMOUNT": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_VEHICLES_CYCLE_REIMBURSED": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_WFH": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_WFH_CARD": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_WFH_CLAIM_CARD": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_WFH_EXPENSES_CARD": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    "EMPLOYMENT_EXPENSES_WFH_EXPENSES_HOURS": "EMPLOYMENT_TEMPORARY_WORKPLACE_EXPENSES_CARD",
    // --- CIS General ---
    "CIS_EMPLOYMENT_PROFILES": "CIS_EMPLOYMENT_PROFILES",
    "CIS_EMPLOYMENT_CATEGORY": "CIS_EMPLOYMENT_CATEGORY",
    "CIS_EMPLOYMENT_CATEGORY_OTHER": "CIS_EMPLOYMENT_CATEGORY",
    // --- CIS Income ---
    "CIS_EMPLOYMENT_CIS_DEDUCTION": "CIS_EMPLOYMENT_INCOME_SUMMARY",
    "CIS_EMPLOYMENT_INCOME_SUMMARY": "CIS_EMPLOYMENT_INCOME_SUMMARY",
    // --- CIS Business Losses ---
    "CIS_EMPLOYMENT_BUSINESS_LOSSES": "CIS_EMPLOYMENT_BUSINESS_LOSSES_CARD",
    "CIS_EMPLOYMENT_BUSINESS_LOSSES_CARD": "CIS_EMPLOYMENT_BUSINESS_LOSSES_CARD",
    "CIS_EMPLOYMENT_BUSINESS_LOSSES_AMOUNT": "CIS_EMPLOYMENT_BUSINESS_LOSSES_CARD",
    // --- CIS Capital Allowances ---
    "CIS_USED_VEHICLE": "CIS_USED_VEHICLE_QUESTION",
    "CIS_USED_VEHICLE_QUESTION": "CIS_USED_VEHICLE_QUESTION",
    "CIS_VEHICLE_DETAILS_ARRAY": "CIS_USED_VEHICLE_QUESTION",
    "CIS_VEHICLE_TYPE": "CIS_USED_VEHICLE_QUESTION",
    "CIS_CAR_MAKE_MODEL": "CIS_USED_VEHICLE_QUESTION",
    "CIS_CAR_CLAIM_METHOD": "CIS_USED_VEHICLE_QUESTION",
    "CIS_MILEAGE_DRIVEN": "CIS_USED_VEHICLE_QUESTION",
    "CIS_CAR_TYPE_NEW_USED": "CIS_USED_VEHICLE_QUESTION",
    "CIS_CAR_PURCHASE_PRICE": "CIS_USED_VEHICLE_QUESTION",
    "CIS_CAR_SALE": "CIS_USED_VEHICLE_QUESTION",
    "CIS_CAR_SALE_DATE": "CIS_USED_VEHICLE_QUESTION",
    "CIS_CAR_SALE_PRICE": "CIS_USED_VEHICLE_QUESTION",
    "CIS_EMPLOYMENT_CAR_PERSONAL_USAGE": "CIS_USED_VEHICLE_QUESTION",
    // --- CIS Expenses ---
    "CIS_EMPLOYMENT_EXPENSES": "CIS_EMPLOYMENT_EXPENSES_SUMMARY",
    "CIS_EMPLOYMENT_EXPENSES_SUMMARY": "CIS_EMPLOYMENT_EXPENSES_SUMMARY",
    // --- Rental General ---
    "RENTAL_PROFILES": "RENTAL_PROFILES",
    "RENTAL_TYPE": "RENTAL_TYPE",
    "RENTAL_NAME": "RENTAL_TYPE",
    "RENTAL_JOINTLY_OWNED_CARD": "RENTAL_TYPE",
    "RENTAL_FOREIGN_PROPERTY_ADDRESS": "RENTAL_TYPE",
    "RENTAL_FOREIGN_INCOME": "RENTAL_TYPE",
    "RENTAL_FOREIGN_SECTION": "RENTAL_TYPE",
    "RENTAL_FOREIGN_PROPERTY_TAX_PAID": "RENTAL_TYPE",
    // --- Rental Income ---
    "RENTAL_INCOME_THRESHOLD": "RENTAL_TYPE",
    "RENTAL_INCOME_THRESHOLD_CARD": "RENTAL_TYPE",
    "RENTAL_MANUAL_INCOME": "RENTAL_MANUAL_INCOME",
    "RENTAL_GROSS_INCOME": "RENTAL_MANUAL_INCOME",
    // --- Rental Mortgage ---
    "RENTAL_MORTGAGE": "RENTAL_MANUAL_INCOME",
    "RENTAL_MORTGAGE_CARD": "RENTAL_MANUAL_INCOME",
    "RENTAL_MORTGAGE_INTEREST_AMOUNT": "RENTAL_MANUAL_INCOME",
    // --- Rental Capital Allowances ---
    "RENTAL_PERSONAL_USAGE": "RENTAL_PERSONAL_USAGE_CARD",
    "RENTAL_PERSONAL_USAGE_CARD": "RENTAL_PERSONAL_USAGE_CARD",
    "RENTAL_PERSONAL_USAGE_DAYS": "RENTAL_PERSONAL_USAGE_CARD",
    "RENTAL_FIXED_MILEAGE_CARD": "RENTAL_PERSONAL_USAGE_CARD",
    "RENTAL_FIXED_MILEAGE_MILES": "RENTAL_PERSONAL_USAGE_CARD",
    // --- Rental Expenses ---
    "RENTAL_EXPENSES": "RENTAL_EXPENSES_SUMMARY",
    "RENTAL_EXPENSES_SUMMARY": "RENTAL_EXPENSES_SUMMARY",
    // --- Pension Income General ---
    "PENSION_INCOME_OPTIONS_APPLY": "PENSION_INCOME_OPTIONS_APPLY",
    "PENSION_INCOME_STATE_AMOUNT": "PENSION_INCOME_OPTIONS_APPLY",
    "PENSION_INCOME_LUMP_SUM": "PENSION_INCOME_OPTIONS_APPLY",
    "PENSION_INCOME_LUMP_SUM_AMOUNT": "PENSION_INCOME_OPTIONS_APPLY",
    "PENSION_INCOME_LUMP_SUM_TAX_PAY": "PENSION_INCOME_OPTIONS_APPLY",
    "PENSION_INCOME_PRIVATE_AMOUNT": "PENSION_INCOME_OPTIONS_APPLY",
    "PENSION_INCOME_PRIVATE_TAX_PAY": "PENSION_INCOME_OPTIONS_APPLY",
    // --- Dividends General ---
    "DIVIDENDS_PROFILES": "DIVIDENDS_PROFILES",
    "DIVIDENDS_NAME": "DIVIDENDS_NAME",
    "DIVIDENDS_TYPE": "DIVIDENDS_NAME",
    "DIVIDENDS_AMOUNT": "DIVIDENDS_AMOUNT",
    "DIVIDENDS_TAX_AMOUNT": "DIVIDENDS_AMOUNT",
    "DIVIDENDS_FOREIGN_INFORMATION": "DIVIDENDS_AMOUNT",
    "DIVIDENDS_FOREIGN_AMOUNT": "DIVIDENDS_AMOUNT",
    "DIVIDENDS_FOREIGN": "DIVIDENDS_AMOUNT",
    "DIVIDENDS_FOREIGN_TAX_PAID": "DIVIDENDS_AMOUNT",
    "DIVIDENDS_FOREIGN_ADDRESS": "DIVIDENDS_AMOUNT",
    // --- Interest Income General ---
    "INTEREST_PROFILES": "INTEREST_PROFILES",
    "INTEREST_NAME": "INTEREST_NAME",
    "INTEREST_TYPE": "INTEREST_NAME",
    "INTEREST_AMOUNT": "INTEREST_AMOUNT",
    "INTEREST_TAX_AMOUNT": "INTEREST_AMOUNT",
    "INTEREST_FOREIGN": "INTEREST_AMOUNT",
    "INTEREST_FOREIGN_INFORMATION": "INTEREST_AMOUNT",
    "INTEREST_FOREIGN_ADDRESS": "INTEREST_AMOUNT",
    "INTEREST_FOREIGN_TAX_PAID": "INTEREST_AMOUNT",
    // --- State Benefits General ---
    "STATE_BENEFITS_OPTIONS_APPLY": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_CHILD_BENEFIT_PARTNER_EARN": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_CHILD_BENEFIT_BENEFIT_PAYMENT": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_CHILD_BENEFIT_CHILDREN": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_CHILD_BENEFIT_STOP_RECEIVING": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_CHILD_BENEFIT_STOP_RECEIVING_DATE": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_JOBSEEKER_ALLOWANCE_PAYMENT": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_JOBSEEKER_ALLOWANCE_TAX_PAID": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_INCAPACITY_BENEFIT_PAYMENT": "STATE_BENEFITS_OPTIONS_APPLY",
    "STATE_BENEFITS_INCAPACITY_BENEFIT_TAX_PAID": "STATE_BENEFITS_OPTIONS_APPLY",
    // --- Capital Gain Loss General ---
    "CAPITAL_GAIN_LOSS_PROFILES": "CAPITAL_GAIN_LOSS_PROFILES",
    "CAPITAL_GAIN_LOSS_TYPE": "CAPITAL_GAIN_LOSS_TYPE",
    "CAPITAL_GAIN_LOSS_ASSET_TYPE": "CAPITAL_GAIN_LOSS_TYPE",
    "CAPITAL_GAIN_LOSS_NAME": "CAPITAL_GAIN_LOSS_TYPE",
    "CAPITAL_GAIN_LOSS_ASSET_VALUES": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_ASSET_SELL_VALUE": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_ASSET_PURCHASE_COST": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_ASSET_GAIN_LOSS": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_GOVERNMENT_REPORTING": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_ASSET_GAIN_LOSS_REPORTED": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_ASSET_TAX_PAID": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_SUPPORTING_DOCUMENT_UPLOAD": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_PREVIOUS_YEAR": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    "CAPITAL_GAIN_LOSS_PREVIOUS_YEAR_AMOUNT": "CAPITAL_GAIN_LOSS_ASSET_SELL_AMOUNT",
    // --- General ---
    "GENERAL_OPTIONS_APPLY": "GENERAL_OPTIONS_APPLY",
    // --- General Marriage Allowance ---
    "GENERAL_MARRIAGE_ALLOWANCE_TRANSFER": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_TRANSFER_TYPE": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_EARN_LESS_THAN_ALLOWANCE": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_CONFIRM_TRANSFER_TO_PARTNER": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_PARTNER_FIRST_NAME": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_PARTNER_LAST_NAME": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_PARTNER_NIN": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_PARTNER_DOB": "GENERAL_OPTIONS_APPLY",
    "GENERAL_MARRIAGE_ALLOWANCE_PARTNER_MARRIAGE_DATE": "GENERAL_OPTIONS_APPLY",
    // --- General Blind Person ---
    "GENERAL_BLIND_PERSON_ALLOWANCE": "GENERAL_OPTIONS_APPLY",
    "GENERAL_BLIND_PERSON_REGISTER": "GENERAL_OPTIONS_APPLY",
    // --- General Pension Contributions ---
    "GENERAL_PENSION_CONTRIBUTIONS": "GENERAL_OPTIONS_APPLY",
    "GENERAL_PENSION_CONTRIBUTION_ITEM_NAME": "GENERAL_OPTIONS_APPLY",
    "GENERAL_PENSION_CONTRIBUTION_ITEM_TYPE": "GENERAL_OPTIONS_APPLY",
    "GENERAL_PENSION_CONTRIBUTION_ITEM_WHEN_MADE": "GENERAL_OPTIONS_APPLY",
    "GENERAL_PENSION_CONTRIBUTION_ITEM_AMOUNT": "GENERAL_OPTIONS_APPLY",
    "GENERAL_PENSION_CONTRIBUTION_ITEM_ONE_OFF_AMOUNT": "GENERAL_OPTIONS_APPLY",
    "GENERAL_PENSION_CONTRIBUTIONS_AMOUNT": "GENERAL_OPTIONS_APPLY",
    "GENERAL_ADDITIONAL_PENSION_CONTRIBUTIONS": "GENERAL_OPTIONS_APPLY",
    "GENERAL_ADDITIONAL_PENSION_CONTRIBUTIONS_AMOUNT": "GENERAL_OPTIONS_APPLY",
    // --- General Charitable Giving ---
    "GENERAL_CHARITABLE_GIVING_NAME": "GENERAL_OPTIONS_APPLY",
    "GENERAL_CHARITABLE_GIVING_AMOUNT": "GENERAL_OPTIONS_APPLY",
    // --- General Venture Capital Scheme ---
    "GENERAL_VENTURE_CAPITAL_SCHEME_PROFILES": "GENERAL_OPTIONS_APPLY",
    "GENERAL_VENTURE_CAPITAL_SCHEME_TYPE": "GENERAL_OPTIONS_APPLY",
    "GENERAL_VENTURE_CAPITAL_SCHEME_NAME": "GENERAL_OPTIONS_APPLY",
    "GENERAL_VENTURE_CAPITAL_SCHEME_UIR": "GENERAL_OPTIONS_APPLY",
    "GENERAL_VENTURE_CAPITAL_SCHEME_COMPANY_NAME": "GENERAL_OPTIONS_APPLY",
    "GENERAL_VENTURE_CAPITAL_SCHEME_AMOUNT": "GENERAL_OPTIONS_APPLY",
    "GENERAL_VENTURE_CAPITAL_SCHEME_DATE": "GENERAL_OPTIONS_APPLY",
    // --- General Student Loan ---
    "GENERAL_STUDENT_LOAN": "GENERAL_STUDENT_LOAN",
    "GENERAL_STUDENT_LOAN_REPAYMENTS": "GENERAL_STUDENT_LOAN",
    "GENERAL_STUDENT_LOAN_PLAN": "GENERAL_STUDENT_LOAN",
    // --- General Payments on Account ---
    "GENERAL_PAYMENTS_ON_ACCOUNT": "GENERAL_PAYMENTS_ON_ACCOUNT",
    "GENERAL_PAYMENTS_ON_ACCOUNT_AMOUNT_JAN": "GENERAL_PAYMENTS_ON_ACCOUNT",
    "GENERAL_PAYMENTS_ON_ACCOUNT_AMOUNT_JUL": "GENERAL_PAYMENTS_ON_ACCOUNT",
    "GENERAL_PAYMENTS_ON_ACCOUNT_AMOUNT_OTHER": "GENERAL_PAYMENTS_ON_ACCOUNT",

};
